import { GetBy } from '../_app/cuchillo/core/Element';
import _Header from '../_app/cuchillo/layout/Header';
import gsap, { Power2, Power3 } from "gsap";
import Flappy from '../components/Flappy';
import { Basics } from '../_app/cuchillo/core/Basics';

export default class SelectScreen {
  static container = GetBy.id("Select");
  static button1 = GetBy.selector("[data-bird]", this.container)[0];
  static button2 = GetBy.selector("[data-bird]", this.container)[1];
  static button3 = GetBy.selector("[data-bird]", this.container)[2];

  static setup() {
    this.container.style.display = "none";
    gsap.set(this.container,{opacity:0});
    
    this.button1.addEventListener('click', () => { this.hide(0); });
    this.button2.addEventListener('click', () => { this.hide(1); });
    this.button3.addEventListener('click', () => { this.hide(2); });
  }

  static show() {
    this.container.style.display = "flex";
    gsap.to(this.container,{opacity:1, ease:Power2.easeIn, duration:.4});
  }

  static hide(__n) {
    Basics.currentBird = __n;
    gsap.to(this.container,{opacity:0, ease:Power2.easeOut, duration:.1, onComplete:()=> {  this.afterHide(); }});
  }

  static afterHide() {
    this.container.style.display = "none";
  }
}


